import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  // Navigation icons
  faGauge,
  faUsers,
  faBuilding,
  faCalendarDays,
  faCreditCard,
  faArrowsUpDown,
  faListCheck,
  faChartColumn,
  faComments,
  faFolder,
  faFileCode,
  faUserTie,
  faUserShield,
  faKey,
  faPalette,
  faGear,
  // Action icons
  faPlus,
  faMinus,
  faPencil,
  faTrash,
  faDownload,
  faUpload,
  faShare,
  faCopy,
  faCheck,
  faXmark,
  faArrowLeft,
  faArrowRight,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faEllipsisVertical,
  faMagnifyingGlass,
  faBell,
  faCircleUser,
  faSun,
  faMoon,
  faBars,
  faRightFromBracket,
  // Resource type icons
  faFileLines,
  faLink,
  faImage,
  faVideo,
  faFileCircleQuestion,
  // Timeline activity icons
  faFileText,
  faEnvelope,
  faPhone,
  faUserGroup,
  faShield,
  faUser,
  faCreditCardAlt,
  faCalendar,
  faClock,
  // Status and UI icons
  faCircleCheck,
  faCircleXmark,
  faCircleInfo,
  faTriangleExclamation,
  faSpinner,
  faArrowUpAZ,
  faArrowDownZA,
  faGripLines,
  faHouse,
  faPaperPlane,
  faThumbtack,
  faArchive,
  faCommentDots,
  faCircle,
  faTableCells,
  faFolderOpen,
  faEye,
  faArrowUpRightFromSquare,
} from '@fortawesome/pro-regular-svg-icons';

export function provideFontAwesome(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: FaIconLibrary,
      useFactory: () => {
        const library = new FaIconLibrary();

        // Add all icons
        library.addIcons(
          // Navigation
          faGauge,
          faUsers,
          faBuilding,
          faCalendarDays,
          faCreditCard,
          faArrowsUpDown,
          faListCheck,
          faChartColumn,
          faComments,
          faFolder,
          faFileCode,
          faUserTie,
          faUserShield,
          faKey,
          faPalette,
          faGear,
          // Actions
          faPlus,
          faMinus,
          faPencil,
          faTrash,
          faDownload,
          faUpload,
          faShare,
          faCopy,
          faCheck,
          faXmark,
          faArrowLeft,
          faArrowRight,
          faChevronLeft,
          faChevronRight,
          faChevronDown,
          faChevronUp,
          faEllipsisVertical,
          faMagnifyingGlass,
          faBell,
          faCircleUser,
          faSun,
          faMoon,
          faBars,
          faRightFromBracket,
          // Resource types
          faFileLines,
          faLink,
          faImage,
          faVideo,
          faFileCircleQuestion,
          // Timeline activities
          faFileText,
          faEnvelope,
          faPhone,
          faUserGroup,
          faShield,
          faUser,
          faCreditCardAlt,
          faCalendar,
          faClock,
          // Status and UI
          faCircleCheck,
          faCircleXmark,
          faCircleInfo,
          faTriangleExclamation,
          faSpinner,
          faArrowUpAZ,
          faArrowDownZA,
          faGripLines,
          faHouse,
          faPaperPlane,
          faThumbtack,
          faArchive,
          faCommentDots,
          faCircle,
          faTableCells,
          faFolderOpen,
          faEye,
          faArrowUpRightFromSquare
        );

        return library;
      },
    },
  ]);
}
